import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Subheading } from "capitalrx-components-2.0/lib/typography";

import { FileUpload } from "@/App/components/FileUpload";

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.directMemberReimbursementUploadClaimEvidenceField";

export type DirectMemberReimbursementUploadClaimEvidenceProps = {
  readonly label: string;
  readonly name: string;
};

export const DirectMemberReimbursementUploadClaimEvidenceField: FC<DirectMemberReimbursementUploadClaimEvidenceProps> = ({ label, name }) => {
  const { t: translate } = useTranslation();

  return (
    <Stack spacing={"medium"}>
      <Subheading>
        {translate(`${TRANSLATION_PATH}.evidenceForClaim`)}
      </Subheading>
      <Body>
        {translate(`${TRANSLATION_PATH}.evidenceForClaimDescription`)}
      </Body>
      <FileUpload.Field
        label={label}
        name={name}
        allowedExtensions={[".pdf", ".png", ".jpg", ".heic"]}
        maxSize={4500000}
        required
        allowMultiple
      />
    </Stack>
  );
};
